/** Types de widget disponibles sur les tableaux de bord objet (ObjectDashboard) et principaux (MainDashboard) */
enum WidgetTypeEnum {
	None = 0,
	Chart = 1,
	Grid = 2,
	Notes = 3,
	News = 4,
	Picture = 5,
	Invoice_Control = 6,
	RemoteReading_Control = 7,
	Gauge = 8,
	Bilan_Pat = 9,
	Bilan_Cons = 10,
	StandBy_Files = 11,
	Ecowatt = 12,
	Figure = 13,
	FigureChart = 14,
	Map = 15,
	ObjectSummary = 16,
	Control = 17,
	Invoices = 18,
	OfficialLabels = 19,
	Factor = 20
}

export default WidgetTypeEnum;